export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4015230771e389b17c873777043e4dde317a6826eb&name=revalidateCommunity!'